// @flow

import type { Action } from './store.type';

export const HANDLE_CHANGE_SWITCH_APP = 'HANDLE_CHANGE_SWITCH_APP';
type HANDLE_CHANGE_SWITCH_APP_TYPE = 'HANDLE_CHANGE_SWITCH_APP';

export const HANDLE_CHANGE_REMOVE_APP = 'HANDLE_CHANGE_REMOVE_APP';
type HANDLE_CHANGE_REMOVE_APP_TYPE = 'HANDLE_CHANGE_REMOVE_APP';

export const HANDLE_CONTINUE_SWITCH_APP_REQUEST = 'HANDLE_CONTINUE_SWITCH_APP_REQUEST';
type HANDLE_CONTINUE_SWITCH_APP_REQUEST_TYPE = 'HANDLE_CONTINUE_SWITCH_APP_REQUEST';

export const HANDLE_CONTINUE_SWITCH_APP_SUCCESS = 'HANDLE_CONTINUE_SWITCH_APP_SUCCESS';
type HANDLE_CONTINUE_SWITCH_APP_SUCCESS_TYPE = 'HANDLE_CONTINUE_SWITCH_APP_SUCCESS';

export const HANDLE_CONTINUE_SWITCH_APP_FAILURE = 'HANDLE_CONTINUE_SWITCH_APP_FAILURE';
type HANDLE_CONTINUE_SWITCH_APP_FAILURE_TYPE = 'HANDLE_CONTINUE_SWITCH_APP_FAILURE';

export const HANDLE_CONTINUE_REMOVE_APP_REQUEST = 'HANDLE_CONTINUE_REMOVE_APP_REQUEST';
type HANDLE_CONTINUE_REMOVE_APP_REQUEST_TYPE = 'HANDLE_CONTINUE_REMOVE_APP_REQUEST';

export const HANDLE_CONTINUE_REMOVE_APP_SUCCESS = 'HANDLE_CONTINUE_REMOVE_APP_SUCCESS';
type HANDLE_CONTINUE_REMOVE_APP_SUCCESS_TYPE = 'HANDLE_CONTINUE_REMOVE_APP_SUCCESS';

export const HANDLE_CONTINUE_REMOVE_APP_FAILURE = 'HANDLE_CONTINUE_REMOVE_APP_FAILURE';
type HANDLE_CONTINUE_REMOVE_APP_FAILURE_TYPE = 'HANDLE_CONTINUE_REMOVE_APP_FAILURE';

export const MARK_OPEN_FULLSCREEN = 'MARK_OPEN_FULLSCREEN';
type MARK_OPEN_FULLSCREEN_TYPE = 'MARK_OPEN_FULLSCREEN';

type AppIntegrationSuccess = {
  data: Object
};

type AppIntegrationFailure = {
  error: any
};

type HandleChangeSwitchApp = Action<HANDLE_CHANGE_SWITCH_APP_TYPE>;

type HandleContinueSwitchAppRequestAction = Action<HANDLE_CONTINUE_SWITCH_APP_REQUEST_TYPE, null>;
type HandleContinueSwitchAppSuccessAction = Action<
  HANDLE_CONTINUE_SWITCH_APP_SUCCESS_TYPE,
  AppIntegrationSuccess
>;
type HandleContinueSwitchAppFailureAction = Action<
  HANDLE_CONTINUE_SWITCH_APP_FAILURE_TYPE,
  AppIntegrationFailure
>;

type HandleChangeRemoveApp = Action<HANDLE_CHANGE_REMOVE_APP_TYPE>;
type HandleContinueRemoveAppRequestAction = Action<HANDLE_CONTINUE_REMOVE_APP_REQUEST_TYPE, null>;
type HandleContinueRemoveAppSuccessAction = Action<
  HANDLE_CONTINUE_REMOVE_APP_SUCCESS_TYPE,
  AppIntegrationSuccess
>;
type HandleContinueRemoveAppFailureAction = Action<
  HANDLE_CONTINUE_REMOVE_APP_FAILURE_TYPE,
  AppIntegrationFailure
>;
type MarkOpenFullScreenAction = Action<MARK_OPEN_FULLSCREEN_TYPE, AppIntegrationFailure>;

export type AppIntegrationAction =
  | HandleChangeSwitchApp
  | HandleContinueSwitchAppRequestAction
  | HandleContinueSwitchAppSuccessAction
  | HandleContinueSwitchAppFailureAction
  | HandleContinueSwitchAppRequestAction
  | HandleContinueSwitchAppSuccessAction
  | HandleContinueSwitchAppFailureAction
  | HandleChangeRemoveApp
  | HandleContinueRemoveAppRequestAction
  | HandleContinueRemoveAppSuccessAction
  | HandleContinueRemoveAppFailureAction
  | MarkOpenFullScreenAction;

export type AppIntegrationState = {
  // Handle change Switch app modal
  switchAppModalActive: boolean,
  switchAppType: string,
  switchAppName: string,
  switchAppKey: string,

  // Switch app
  switchAppLoading: boolean,
  switchAppSuccess: boolean,

  // Handle change Remove app modal
  removeAppModalActive: boolean,
  removeAppType: string,
  removeAppName: string,

  // Remove app
  removeAppLoading: boolean,
  removeAppSuccess: boolean,

  // Flag check open fullscreen
  openFullscreen: false,

  loading: boolean,
  success: boolean,
  error: any
};
